module.exports = __webpack_public_path__ + "img/new_business.167e5673.svg";